<template>
  <div class="c-item" @click="clickHandle">
    <div class="c-thumb c-default-img">
      <img :src="item.imageA+'?x-oss-process=image/resize,m_mfit,h_178,w_320'" />
    </div>
    <div>
      <div class="c-title thidden">{{item.name}}</div>
      <div class="c-subtitle thidden">{{item.shareDescription}}</div>
      <div class="c-course-info">
        <div class="c-price">￥{{item.newPrice}}</div>
        <div class="c-lesson-progress" v-if="item.type == constants.goodsType.course">{{item.saleNum}}人学习</div>
        <div class="c-lesson-progress" v-if="item.type == constants.goodsType.column">共{{item.courseCount}}门课</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  emits: ['click'],
  methods: {
    clickHandle() {
      this.$emit('click', this.item)
    },
  },
}
</script>

<style lang="less" scoped>
.c-item {
  display: flex;
  .c-thumb {
    width: 320px;
    height: 178px;
    border-radius: 10px;
    margin-right: 20px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .c-title {
    width: 354px;
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .c-subtitle {
    width: 354px;
    font-size: 26px;
    font-weight: 400;
    color: #666666;
    line-height: 54px;
  }
  .c-course-info {
    display: flex;
    justify-content: space-between;
    padding-top: 50px;
    line-height: 1;
    .c-lesson-progress {
      flex: 50% 0 0;
      width: 142px;
      text-align: right;
      font-size: 26px;
      font-weight: 400;
      color: #888888;
    }
    .c-price {
      font-size: 28px;
      font-weight: 500;
      color: #ff5500;
    }
  }
}
</style>